import React from "react";
import { Redirect } from "react-router-dom";

import { stripNumber } from "../lib/helpSlug";

/**
 * `/category/:category/:legacy` -> `/:category/:slug`.
 *
 * Until October 2026 every article lived under `/category/...` with its file
 * number in the slug, and those URLs are everywhere: hanamaru's price
 * breakdown, the PayPal logo in the footer, old chats. In production nginx
 * answers them with a real 301 before this app loads (deployment/nginx.conf);
 * this component covers the dev server and any client-side navigation.
 *
 * The number is stripped rather than looked up, so a link to
 * `05-membayar-lewat-ecommerce` lands on the article even though the file has
 * since been renumbered. Query (webview) and hash (#price-jpy) are kept.
 */
const LegacyRedirect = ({ match, location }) => {
  const { category, legacy } = match.params;

  let pathname = "/";
  if (category && legacy) pathname = `/${category}/${stripNumber(legacy)}`;
  else if (category) pathname = `/${category}`;

  return <Redirect to={{ pathname, search: location.search, hash: location.hash }} />;
};

export default LegacyRedirect;
